<template>
  <nav class="shard-nav">
    <div class="logo" @click="close">
      <router-link to="/">
        Shard Studio
      </router-link>
    </div>
    <div @click="toggleNavigation" class="hamburger" v-bind:class="{ active: open }">
      <span></span>
    </div>
    <div class="menu" v-bind:class="{ active: open }">
      <ul>
        <li>
          <router-link to="/devblog">
            <button @click="close">devblog</button>
          </router-link>
        </li>
        <li v-if="!logged">
          <router-link to="/signin">
            <button @click="close">sign in</button>
          </router-link>
        </li>
        <li v-if="logged">
          <router-link to="/account">
            <button @click="close">account</button>
          </router-link>
        </li>
        <li v-if="logged">
          <button @click="signOut(); close()">sign out</button>
        </li>
      </ul>
    </div>
  </nav>
</template>

<script>
/* eslint-disable */
import { EventBus } from '../event-bus.js'

export default {
  name: 'ShardNav',
  components: {
  },
  data () {
    return {
      logged: false,
      open: false
    }
  },
  methods: {
    signOut () {
      EventBus.$emit('sign-out')
    },
    toggleNavigation () {
      this.open = !this.open
    },
    close () {
      this.open = false
    }
  },
  mounted () {
    const self = this

    EventBus.$on('logged-on', function () {
      self.logged = true
    })

    EventBus.$on('logged-off', function () {
      self.logged = false
    })
  }
}
</script>

<style lang="scss" scoped>
.shard-nav {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 65px;
  background: black;
  background: linear-gradient(to bottom, rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 0) 100%);
  z-index: 4;
}

.logo {
  position: absolute;
  top: 20px;
  left: 20px;
  z-index: 5;
  box-sizing: border-box;

  a {
    display: block;
    text-decoration: none;
    font-family: 'Roboto', Arial, sans-serif;
    font-weight: 700;
    color: white;
    padding: 7px 15px;
    letter-spacing: 2px;
    text-transform: uppercase;
    font-size: .7em;
    transition: opacity .2s ease-in-out;

    &:hover {
      opacity: .8;
    }
  }
}

.menu {
  position: absolute;
  top: 20px;
  right: 20px;
  z-index: 4;

  ul {
    @media screen and (max-width: 500px) {
      display: none;
    }
  }

  li {
    display: inline-block;
  }

  button {
    letter-spacing: 2px;
    background: transparent;
    border: none;
    padding: 7px 15px;
    text-transform: uppercase;
    font-weight: bold;
    font-size: .7em;
    color: white;
    cursor: pointer;
    transition: all .2s ease-in-out;
    outline: none;

    &:hover {
      opacity: .8;
    }
  }

  &.active {
    @media screen and (max-width: 500px) {
      display: block;

      ul {
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        width: 100%;
        background: black;
        display: inline-flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        transition: all .2s ease-in-out;
        animation: open .2s ease-in-out forwards;

        @keyframes open {
          0% {
            display: inline-flex;
            opacity: 0;
          }
          1% {
            opacity: 0;
          }
          100% {
            opacity: 1;
          }
        }

        &::before {
          content: '';
          position: absolute;
          left: -100px;
          top: 0;
          transform: rotate(-45deg);
          height: 20px;
          background: #E91E63;
          z-index: 1;
          width: 400px;
        }

        li {
          display: block;
          text-align: center;

          button {
            margin: 10px;
            font-size: 20px;
          }
        }
      }
    }
  }
}

.hamburger {
  position: fixed;
  left: calc(100% - 20px - 20px - 20px);
  top: 10px;
  z-index: 5;
  display: block;
  width: 40px;
  height: 40px;
  padding: 10px;
  cursor: pointer;

  @media screen and (min-width: 500px) {
    display: none;
  }

  span, span::before, span::after {
    transition: all .15s ease-in-out;
  }

  span {
    display: block;
    height: 1px;
    background: white;
    width: 20px;
    position: absolute;
    top: 50%;

    &::before, &::after {
      content: '';
      display: block;
      height: 1px;
      background: white;
      width: 20px;
    }

    &::before {
      position: absolute;
      top: -6px;
    }

    &::after {
      position: absolute;
      top: 6px;
    }
  }

  &.active {
    span {
      background: transparent;

      &::before {
        transform: rotate(45deg);
        top: 50%;
      }

      &::after {
        transform: rotate(-45deg);
        top: 50%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/shard-nav.vue